import React, { useEffect, useState } from "react";
import Nav from "../components/navbar";
import Toptitle from "../components/pagetop";
import "../style.css";
import { BsFillBookmarkFill } from "react-icons/bs";
import { UserAuth } from "../context/authContext";
import underDev from "../assets/underDev.json";
import Lottie from "lottie-react";
import { useNavigate } from "react-router-dom";
import {
  collection,
  getDoc,
  getDocs,
  doc,
  query,
  where,
  documentId,
  onSnapshot,
  deleteDoc,
} from "firebase/firestore";
import { db } from "../firebase-config";
import { motion } from "framer-motion";
import BookmarkPost from "../components/BookmarkPost";

export default function Bookmarks() {
  const [bookmarks, setBookmarks] = useState([]);
  const [loader, setLoader] = useState(true);

  const { user } = UserAuth();

  const getBookmarks = async () => {
    const colRef = collection(db, "users", user.uid, "Bookmarks");

    onSnapshot(colRef, (snapshot) => {
      let tempBooks = [];
      snapshot.forEach((book) => {
        tempBooks.push({ id: book.id, data: book.data() });
      });
      setBookmarks(tempBooks);
    });
    setLoader(false);
  };

  useEffect(() => {
    getBookmarks();
  }, []);

  const handleDelete = async (postID) => {
    const docRef = doc(db, "users", user.uid, "Bookmarks", postID);

    await deleteDoc(docRef);
    setInfo([]);
  };

  const [info, setInfo] = useState([]);

  let navigate = useNavigate();

  const routeChange = (titre, identifier) => {
    const nav = `/post/${titre}=${identifier}`;
    navigate(nav);
  };

  let navigator = useNavigate();

  const profChange = (name, userID) => {
    const replaced = name.replace(" ", "");
    const nav = `/profile/@${replaced}`;
    navigator(nav, { state: { userID: userID } });
  };

  return (
    <div className="mainWrapper ">
      <Nav />
      <div className="innerwrapper overflow-y-auto p-0  bgAccount">
        <Toptitle title="Bookmarks" bg="transparent" />
        <div
          className={
            bookmarks.length > 0
              ? "mt-2 h-[32rem] px-7 w-full flex flex-row gap-7 "
              : "mt-2 h-[32rem] px-7 w-full flex flex-row justify-center items-center gap-7 "
          }
        >
          {bookmarks.length > 0 ? (
            <div className="w-full h-full flex flex-row-reverse justify-between overflow-auto ">
              <motion.div
                className="w-[55%] flex flex-col gap-3 overflow-y-auto"
                animate={{ opacity: 1, x: 0 }}
                initial={{ opacity: 0, x: 40 }}
                transition={{ ease: "easeInOut", duration: 0.4 }}
              >
                {bookmarks &&
                  bookmarks.map(
                    (book, index) =>
                      book.id !== "dummy" && (
                        <motion.div
                          key={index}
                          className="w-[97%] h-32  bg-[#191919] rounded-xl flex flex-row p-1 justify-between cursor-pointer hover:bg-[#121212] transition-all ease-in-out"
                          animate={{ opacity: 1 }}
                          initial={{ opacity: 0 }}
                          transition={{
                            ease: "easeInOut",
                            duration: 0.3,
                          }}
                          exit={{ opacity: 0 }}
                        >
                          <div
                            className="h-32 w-[35%] overflow-hidden rounded-xl"
                            onClick={() => {
                              routeChange(book.data.title, book.data.postID);
                            }}
                          >
                            <img
                              src={book.data.postPic}
                              className="w-full h-full object-cover"
                            />
                          </div>
                          <div className="h-full w-[63%] flex flex-col justify-between">
                            <div
                              className="flex flex-col"
                              onClick={() => {
                                routeChange(book.data.title, book.data.postID);
                              }}
                            >
                              <div className="text-sm text-DarkBlue">
                                {book.data.postCategory}
                              </div>
                              <div className="text-zinc-100 font-medium mt-1 pr-3">
                                {book.data.title}
                              </div>
                            </div>

                            <div className="w-full flex flex-row justify-between items-center relative">
                              <div
                                className="flex flex-row"
                                onClick={() =>
                                  profChange(
                                    book.data.name,
                                    book.data.postPublisher
                                  )
                                }
                              >
                                <div className="w-8 h-8 rounded-full overflow-hidden">
                                  <img
                                    src={book.data.profPic}
                                    className="w-full h-full object-cover"
                                  />
                                </div>
                                <div className="ml-2 self-center font-medium text-zinc-400 capitalize">
                                  {book.data.name}
                                </div>
                              </div>

                              <BsFillBookmarkFill
                                size={26}
                                className="self-center fill-OrangyRed animate-scale w-[12%] absolute right-0 cursor-pointer z-50"
                                onClick={() => {
                                  handleDelete(book.data.postID);
                                }}
                              />
                            </div>
                          </div>
                        </motion.div>
                      )
                  )}
              </motion.div>
              <motion.div
                className="w-[43%] h-full rounded-xl flex flex-col items-center justify-center"
                animate={{ opacity: 1 }}
                initial={{ opacity: 0 }}
                transition={{
                  ease: "easeIn",
                  duration: 0.4,
                }}
                exit={{ opacity: 0 }}
              >
                <Lottie
                  animationData={underDev}
                  loop={true}
                  style={{ width: "90%" }}
                />
                <div className="text-sm text-zinc-600">
                  Save interesting articles into personalized collections
                </div>
                <div className="mt-2 text-OrangyRed font-semibold">
                  This feature is under development
                </div>
              </motion.div>
            </div>
          ) : (
            <motion.div
              className="flex flex-row items-center"
              animate={{ opacity: 1 }}
              initial={{ opacity: 0 }}
              transition={{
                ease: "easeIn",
                duration: 0.4,
              }}
              exit={{ opacity: 0 }}
            >
              Add your favorite articles to your bookmarks. Simply click the{" "}
              <BsFillBookmarkFill
                size={27}
                className="self-center fill-zinc-300 mx-2"
              />{" "}
              on any SkyShare article to get started.
            </motion.div>
          )}
        </div>
      </div>
    </div>
  );
}
